import React, { useState, useLayoutEffect } from 'react';
import { View, Text, Dimensions } from 'react-native';
import Gallery from 'react-native-image-gallery';
import { responsiveFontSize, responsiveHeight } from 'react-native-responsive-dimensions';


export default function GallerySwipper({ route, navigation }) {
	
	const { index: indexInit, images: imagesTemp } = route.params;
	const images = imagesTemp.filter( image => image.empty ? false : true );

	const [index, setIndex] = useState(indexInit);


	const onChangeImage = (index) => {
		setIndex(index);
	}

	return (
		<View style={{flex:1}}>
			<Gallery
			  style={{ flex: 1, backgroundColor: 'black' }}
			  images={images}
			  flatListProps={{
			    windowSize: 3, // limits memory usage to 3 screens full of photos (ie. 3 photos)
			    initialNumToRender: 3, // limit amount, must also be limited, is not controlled by other props
			    maxToRenderPerBatch: 2, // when rendering ahead, how many should we render at the same time
			    getItemLayout: (data, index) => ({ // fixes scroll and pinch behavior
			      length: Dimensions.get('screen').width,
			      offset: Dimensions.get('screen').width * index,
			      index,
			    }),
			  }}
			  removeClippedSubviews
			  initialPage={index}
			  onPageSelected={onChangeImage}
			/>

	      	<View style={{ bottom: 0, height: responsiveHeight(20), width: '100%', position: 'absolute', justifyContent: 'center' }}>
	      		<Text style={ {fontSize: responsiveFontSize(2.5), fontStyle: 'italic', color: 'white', textAlign: 'center'} }> { images[index].description }</Text>
            </View>
      	</View>
	)
}